import { useEffect, useState } from "react";
import { Plus, X } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const TYPES = [
  { key: "category", label: "Categories" },
  { key: "audience", label: "Audiences" },
  { key: "size", label: "Sizes" },
  { key: "color", label: "Colors" },
  { key: "fabric", label: "Fabrics" },
];

export default function AdminAttributes() {
  const [attrs, setAttrs] = useState({ category: [], audience: [], size: [], color: [], fabric: [] });
  const [inputs, setInputs] = useState({});

  const load = () => { api.get("/attributes").then((r) => setAttrs(r.data)).catch(() => {}); };
  useEffect(() => { load(); }, []);

  const add = async (type) => {
    const value = (inputs[type] || "").trim();
    if (!value) return;
    try {
      await api.post("/attributes", { type, value });
      setInputs({ ...inputs, [type]: "" });
      toast.success(`Added "${value}"`);
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Could not add"); }
  };

  const remove = async (type, value) => {
    await api.delete("/attributes", { params: { type, value } });
    toast.success(`Removed "${value}"`);
    load();
  };

  return (
    <div>
      <h1 className="font-display text-2xl font-bold mb-1">Attributes</h1>
      <p className="text-sm text-muted-foreground mb-6">Manage the filter options shown on the store. Changes appear instantly.</p>
      <div className="grid md:grid-cols-2 gap-5">
        {TYPES.map((t) => (
          <div key={t.key} className="bg-card border border-border rounded-2xl p-5">
            <h2 className="font-semibold mb-3">{t.label}</h2>
            <div className="flex flex-wrap gap-2 mb-4">
              {(attrs[t.key] || []).map((v) => (
                <span key={v} className="inline-flex items-center gap-1.5 bg-secondary rounded-full pl-3 pr-2 py-1 text-sm" data-testid={`attr-${t.key}-${v}`}>
                  {v}
                  <button onClick={() => remove(t.key, v)} className="text-muted-foreground hover:text-destructive" data-testid={`attr-del-${t.key}-${v}`}><X className="w-3.5 h-3.5" /></button>
                </span>
              ))}
              {(attrs[t.key] || []).length === 0 && <span className="text-sm text-muted-foreground">None yet</span>}
            </div>
            <div className="flex gap-2">
              <input value={inputs[t.key] || ""} onChange={(e) => setInputs({ ...inputs, [t.key]: e.target.value })}
                onKeyDown={(e) => e.key === "Enter" && add(t.key)} placeholder={`Add ${t.label.slice(0, -1).toLowerCase()}…`} data-testid={`attr-input-${t.key}`}
                className="flex-1 rounded-xl bg-secondary border border-input px-3 py-2 text-sm outline-none focus:border-primary" />
              <button onClick={() => add(t.key)} className="bg-primary text-primary-foreground rounded-xl px-3 flex items-center" data-testid={`attr-add-${t.key}`}><Plus className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
